import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { getAllStandardMaintenanceItems } from "../../../redux/StandardMaintenanceItemSlice/StandardMaintenanceItemSlice";
import { getAllMaintenanceScheduleById } from "../../../redux/MaintenanceScheduleSlice/MaintenanceScheduleSlice";
import {
  createBulkMaintenanceItem,
  createBulkMaintenanceItemByContract,
  updateMaintenanceItem,
} from "../../../redux/MaintenanceItemSlice/MaintenanceItemSlice";
import notify from "../../../hooks/useNotifaction";
import Select from "react-select";

function AddMaintenanceItemToSchadules() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { ContractId, ScheduleId } = useParams();

  const { allStandardMaintenanceItems } = useSelector(
    (state) => state.standardMaintenanceItems
  );
  const { specificMaintenanceSchedule } = useSelector(
    (state) => state.maintenanceSchedule
  );

  const [itemsOptions, setItemsOptions] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  // تحديد إذا كان المسار للـ Contract أو Schedule
  const isContractRoute =
    location.pathname.includes("/Contracts/") &&
    location.pathname.includes("/AddStandardMaintenanceItem");

  useEffect(() => {
    dispatch(getAllStandardMaintenanceItems());
    if (ScheduleId) dispatch(getAllMaintenanceScheduleById(ScheduleId));
  }, [dispatch, ScheduleId]);

useEffect(() => {
  if (allStandardMaintenanceItems?.data?.length) {
    const mapItemsRecursive = (items) =>
      items.flatMap((item) => {
        const current = { label: item.name, value: item.id };
        return item.children?.length
          ? [current, ...mapItemsRecursive(item.children)]
          : [current];
      });

    setItemsOptions(mapItemsRecursive(allStandardMaintenanceItems.data));
  }
}, [allStandardMaintenanceItems]);

  useEffect(() => {
    if (specificMaintenanceSchedule?.scheduleItems && itemsOptions.length > 0) {
      const defaultSelected = specificMaintenanceSchedule.scheduleItems
        .map((item) => {
          const matchOpt = itemsOptions.find(
            (opt) => opt.value === item.standard_item_id
          );
          return matchOpt
            ? {
                ...matchOpt,
                quantity: item.quantity || 1,
                existingId: item.id,
              }
            : null;
        })
        .filter(Boolean);

      setSelectedItems(defaultSelected);
    }
  }, [itemsOptions, specificMaintenanceSchedule]);

  const handleChangeItems = (selected) => {
    if (!Array.isArray(selected)) {
      setSelectedItems([]);
      return;
    }

    const updated = selected.map((item) => {
      const existing = selectedItems.find((i) => i.value === item.value);
      return existing ? existing : { ...item, quantity: 1 };
    });

    setSelectedItems(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // إذا كان المسار للـ Contract
      if (isContractRoute && ContractId) {
        const itemsData = selectedItems.map((item) => ({
          standard_item_id: item.value,
          quantity: item.quantity,
          status: "pending",
        }));

        console.log("Create by Contract", itemsData);
        await dispatch(
          createBulkMaintenanceItemByContract({
            contract_id: ContractId,
            items: itemsData,
          })
        ).unwrap();

        notify("تم إضافة العناصر للعقد بنجاح", "success");
        navigate("/Contracts");
        return;
      }

      // إذا كان المسار للـ Schedule (الكود القديم)
      const itemsToCreate = [];
      const itemsToUpdate = [];

      selectedItems.forEach((item) => {
        if (item.existingId) {
          itemsToUpdate.push({
            id: item.existingId,
            quantity: item.quantity,
          });
        } else {
          itemsToCreate.push({
            standard_item_id: item.value,
            quantity: item.quantity,
          });
        }
      });

      if (itemsToCreate.length > 0) {
        console.log("Create", itemsToCreate);
        await dispatch(
          createBulkMaintenanceItem({
            schedule_ids: [ScheduleId],
            items: itemsToCreate,
          })
        ).unwrap();
      }

      if (itemsToUpdate.length > 0) {
        console.log("Update", itemsToUpdate);
        const res = await dispatch(
          updateMaintenanceItem({ items: itemsToUpdate })
        ).unwrap();
        console.log(res);
      }

      notify("تم حفظ التعديلات بنجاح", "success");
      navigate("/MaintenanceSchedules");
    } catch (err) {
      console.error(err);
      notify(err?.message || "حدث خطأ أثناء الحفظ", "error");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-3 pt-5 pb-2 px-3 companyProfile">
        <section className="row mb-5">
          <h4>
            <span>
              {isContractRoute ? "إضافة عناصر للعقد" : "إضافة العناصر"}
            </span>
          </h4>

          <div className="col-12 mt-3 mb-2">
            <Select
              options={itemsOptions}
              value={selectedItems}
              placeholder="اختر العناصر الأساسية"
              isSearchable
              isMulti
              menuPortalTarget={document.body}
              onChange={handleChangeItems}
              classNames={{
                control: (state) =>
                  state.isFocused ? "selectSearchFocus" : "selectSearch",
              }}
            />
          </div>

          {selectedItems.length > 0 && (
            <div className="mt-4">
              {selectedItems.map((item) => (
                <div
                  key={item.value}
                  className="d-flex align-items-center mb-2 gap-3"
                >
                  <span style={{ minWidth: "200px" }}>{item.label}</span>

                  <input
                    type="number"
                    min="1"
                    className="form-control"
                    style={{ width: "120px" }}
                    value={item.quantity}
                    onChange={(e) => {
                      const qty = Number(e.target.value);
                      setSelectedItems((prev) =>
                        prev.map((it) =>
                          it.value === item.value
                            ? { ...it, quantity: qty }
                            : it
                        )
                      );
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        </section>

        <div>
          <button type="submit" className="btn btn-primary">
            <i className="fas fa-plus me-1"></i>
            إضافة
          </button>
        </div>
      </div>
    </form>
  );
}

export default AddMaintenanceItemToSchadules;
